import {
  AI_STUDIO_SET_LOADING,
  AI_STUDIO_SET_ERROR,
  AI_STUDIO_RESET,
  AI_STUDIO_SET_STUDIOS,
  AI_STUDIO_SET_CURRENT_STUDIO,
  AI_STUDIO_LOADING_STATUS,
  AI_STUDIO_ACTION_DETECTED,
  AI_STUDIO_AI_ANSWER,
  AI_STUDIO_AI_ERROR,
  AI_STUDIO_STREAM_CHUNK,
  AI_STUDIO_STREAM_DONE,
  AI_STUDIO_STREAM_RESET,
  AI_STUDIO_MEDIA_BLOCK,
  AI_STUDIO_MEDIA_STATUS,
  AI_STUDIO_MEDIA_DONE,
} from "./AIStudioTypes";

const initialState = {
  loading: false,
  error: null,
  loadingStatus: null,
  action: null,
  answer: null,
  streamChunks: [],
  streamDone: false,
  mediaBlock: null,
  mediaStatus: null,
  mediaDonePayload: null,
  studios: [],
  currentStudio: null,
};

export const aiStudioReducer = (state = initialState, action) => {
  switch (action.type) {
    case AI_STUDIO_SET_LOADING:
      return {
        ...state,
        loading: Boolean(action.payload),
        ...(action.payload ? { error: null } : {}),
      };
    case AI_STUDIO_SET_ERROR:
      return {
        ...state,
        error: action.payload ?? null,
        loading: false,
      };
    case AI_STUDIO_LOADING_STATUS:
      return { ...state, loadingStatus: action.payload ?? null };
    case AI_STUDIO_ACTION_DETECTED:
      return { ...state, action: action.payload ?? null };
    case AI_STUDIO_AI_ANSWER:
      return {
        ...state,
        loading: false,
        answer: action.payload ?? null,
        error: null,
        loadingStatus: null,
        streamDone: true,
      };
    case AI_STUDIO_AI_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload ?? null,
        answer: null,
        loadingStatus: null,
      };
    case AI_STUDIO_STREAM_CHUNK: {
      const chunk = action.payload?.chunk ?? action.payload;
      return {
        ...state,
        streamChunks: chunk != null ? [...state.streamChunks, chunk] : state.streamChunks,
      };
    }
    case AI_STUDIO_STREAM_DONE:
      return {
        ...state,
        streamDone: true,
        loading: false,
        loadingStatus: null,
      };
    case AI_STUDIO_MEDIA_BLOCK:
      return { ...state, mediaBlock: action.payload ?? null };
    case AI_STUDIO_MEDIA_STATUS:
      return { ...state, mediaStatus: action.payload ?? null };
    case AI_STUDIO_MEDIA_DONE:
      return { ...state, mediaDonePayload: action.payload ?? null };
    case AI_STUDIO_STREAM_RESET:
      return {
        ...state,
        streamChunks: [],
        streamDone: false,
        mediaBlock: null,
        mediaStatus: null,
        mediaDonePayload: null,
      };
    case AI_STUDIO_RESET:
      return initialState;
    case AI_STUDIO_SET_STUDIOS:
      return { ...state, studios: action.payload ?? [] };
    case AI_STUDIO_SET_CURRENT_STUDIO:
      return { ...state, currentStudio: action.payload ?? null };
    default:
      return state;
  }
};
